import type { ReactNode } from "react";
import { tokens } from "@core/theme/tokens";

// SPEC-201 §4.1: estructura común de listado — búsqueda, filtros, tabla,
// acciones por fila, conteo total siempre visible, filtros limpiables de a
// uno o todos juntos.

export interface ActiveFilter {
  key: string;
  label: string;
  onClear: () => void;
}

export function ListLayout({
  search,
  filters,
  onClearAllFilters,
  children,
}: {
  search?: ReactNode;
  filters?: ActiveFilter[];
  onClearAllFilters?: () => void;
  children: ReactNode;
}) {
  const hasFilters = Boolean(filters?.length);

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          minHeight: 44,
          padding: 14,
          marginBottom: 16,
          border: `1px solid ${tokens.surface.line}`,
          borderRadius: 18,
          background: tokens.surface.bg2,
        }}
      >
        {search}
      </div>

      {hasFilters ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 8,
            alignItems: "center",
            marginBottom: 16,
          }}
        >
          {filters?.map((f) => (
            <button
              key={f.key}
              type="button"
              className="chip"
              onClick={f.onClear}
              style={{ font: `500 12px ${tokens.font.ui}` }}
            >
              {f.label} ×
            </button>
          ))}
          {onClearAllFilters ? (
            <button
              type="button"
              onClick={onClearAllFilters}
              style={{
                font: `600 12px ${tokens.font.ui}`,
                color: tokens.text.tertiary,
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
            >
              Limpiar todo
            </button>
          ) : null}
        </div>
      ) : null}

      {children}
    </div>
  );
}
